var app = angular.module('leonardo');

var ReportFilterService = function(FilterService, TaskService, AccountUserActivityService, WorkFlowInstanceService,
                                   DynamicFormDataRestService, AccountService, ReportService, ngDialog, $q,
                                   TemplateService, PropertyService, AccountUserService, FolderFileService,
                                   WorkOrderService, PropertyAmenityService, ContactRestService) {
  var service = {};

  service.fieldInvalidTypes = ['sectionDivider', 'freeText'];

  service.selectedOptionFieldToShow = [];

  service.filter = function(filters, report_type) {
    angular.forEach(filters, function(value, key) {
      if ((key !== 'dynamic_filters') && (key !== 'include_tags') && (key !== 'lookup_filters') && (key !== 'triggered_tasks') && value){
        if(angular.isArray(value)) {
          filters[key] = value.join (',');
        }
        else{
          filters[key] = value.toString();
        }
      }
      else {
        filters[key] = value;
      }
    });
    var defer = $q.defer();
    switch(report_type.toString()) {
      case ReportService.TYPE_ACTION_ITEM:
        TaskService.getReports(filters).then(function(results){
          if (!results.meta) {
            results.meta = {
              previous: results.previous,
              next: results.next,
              count: results.count
            };
          }
          defer.resolve(results);
        }, function(error){
          if (filters['page']){
            delete(filters['page']);
            FilterService.removeFilter('page');
            defer.resolve(service.filter(filters, ReportService.TYPE_ACTION_ITEM));
          }
          else {
            defer.reject(error);
          }
        });
        break;
      case ReportService.TYPE_CONTACT:
        ContactRestService.getReports(filters).then(function(results){
          if (!results.meta) {
            results.meta = {
              previous: results.previous,
              next: results.next,
              count: results.count
            };
          }
          defer.resolve(results);
        }, function(error){
          if (filters['page']){
            delete(filters['page']);
            FilterService.removeFilter('page');
            defer.resolve(service.filter(filters, ReportService.TYPE_CONTACT));
          }
          else {
            defer.reject(error);
          }
        });
        break;
      case ReportService.TYPE_ACTIVITY:
        AccountUserActivityService.getReports(filters).then(function(results){
          if (!results.meta) {
            results.meta = {
              previous: results.previous,
              next: results.next,
              count: results.count
            };
          }
          defer.resolve(results);
        }, function(error){
          if (filters['page']){
            delete(filters['page']);
            FilterService.removeFilter('page');
            defer.resolve(service.filter(filters, ReportService.TYPE_ACTIVITY));
          }
          else {
            defer.reject(error);
          }
        });
        break;
      case ReportService.TYPE_UNIT:
        WorkFlowInstanceService.getReports(filters).then(function(results){
          if (!results.meta) {
            results.meta = {
              previous: results.previous,
              next: results.next,
              count: results.count
            };
          }
          defer.resolve(results);
        }, function(error){
          if (filters['page']) {
            delete(filters['page']);
            FilterService.removeFilter('page');
            defer.resolve(service.filter(filters, ReportService.TYPE_UNIT));
          }
          else {
            defer.reject(error);
          }
        });
        break;
      case ReportService.TYPE_WORKFLOW:
        WorkFlowInstanceService.getReports(filters).then(function(results){
          if (!results.meta) {
            results.meta = {
              previous: results.previous,
              next: results.next,
              count: results.count
            };
          }
          defer.resolve(results);
        }, function(error){
          if (filters['page']) {
            delete(filters['page']);
            FilterService.removeFilter('page');
            defer.resolve(service.filter(filters, ReportService.TYPE_WORKFLOW));
          }
          else {
            defer.reject(error);
          }
        });
        break;
      case ReportService.TYPE_DYNAMIC_FORM_STATISTIC:
        WorkFlowInstanceService.getStatisticReports(filters).then(function(results){
          if (!results.meta) {
            results.meta = {
              previous: results.previous,
              next: results.next,
              count: results.count
            };
          }
          defer.resolve(results);
        }, function(error){
          if (filters['page']) {
            delete(filters['page']);
            FilterService.removeFilter('page');
            defer.resolve(service.filter(filters, ReportService.TYPE_DYNAMIC_FORM_STATISTIC));
          }
          else {
            defer.reject(error);
          }
        });
        break;
      case ReportService.TYPE_DYNAMIC_FORM:
        filters['fetch_resident'] = true;
        DynamicFormDataRestService.getReports(filters).then(function(results){
          if (!results.meta) {
            results.meta = {
              previous: results.previous,
              next: results.next,
              count: results.count
            };
          }
          defer.resolve(results);
        }, function(error){
          if (filters['page']){
            delete(filters['page']);
            FilterService.removeFilter('page');
            defer.resolve(service.filter(filters, ReportService.TYPE_DYNAMIC_FORM));
          }
          else {
            defer.reject(error);
          }
        });
        break;
      case ReportService.TYPE_BILLING:
        AccountService.getBillingReports(filters).then(function(results){
          if (!results.meta) {
            results.meta = {
              previous: results.previous,
              next: results.next,
              count: results.count
            };
          }
          defer.resolve(results);
        }, function(error){
          if (filters['page']){
            delete(filters['page']);
            FilterService.removeFilter('page');
            defer.resolve(service.filter(filters, ReportService.TYPE_BILLING));
          }
          else {
            defer.reject(error);
          }
        });
        break;
      case ReportService.TYPE_TEMPLATE:
        TemplateService.getReports(filters).then(function(results){
          if (!results.meta) {
            results.meta = {
              previous: results.previous,
              next: results.next,
              count: results.count
            };
          }
          defer.resolve(results);
        }, function(error){
          if (filters['page']) {
            delete(filters['page']);
            FilterService.removeFilter('page');
            defer.resolve(service.filter(filters, ReportService.TYPE_TEMPLATE));
          }
          else {
            defer.reject(error);
          }
        });
        break;
      case ReportService.TYPE_PROPERTY:
        PropertyService.getReports(filters).then(function(results){
          if (!results.meta) {
            results.meta = {
              previous: results.previous,
              next: results.next,
              count: results.count
            };
          }
          defer.resolve(results);
        }, function(error){
          if (filters['page']) {
            delete(filters['page']);
            FilterService.removeFilter('page');
            defer.resolve(service.filter(filters, ReportService.TYPE_PROPERTY));
          }
          else {
            defer.reject(error);
          }
        });
        break;
      case ReportService.TYPE_PROPERTY_AMENITIES:
        PropertyAmenityService.getReports(filters).then(function (results) {
          if (!results.meta) {
            results.meta = {
              previous: results.previous,
              next: results.next,
              count: results.count
            };
          }
          defer.resolve(results);
        }, function (error) {
          if (filters['page']) {
            delete (filters['page']);
            FilterService.removeFilter('page');
            defer.resolve(service.filter(filters, ReportService.TYPE_PROPERTY_AMENITIES));
          }
          else {
            defer.reject(error);
          }
        });
        break;
      case ReportService.TYPE_USER:
        AccountUserService.getReports(filters).then(function(results){
          if (!results.meta) {
            results.meta = {
              previous: results.previous,
              next: results.next,
              count: results.count
            };
          }
          defer.resolve(results);
        }, function(error){
          if (filters['page']) {
            delete(filters['page']);
            FilterService.removeFilter('page');
            defer.resolve(service.filter(filters, ReportService.TYPE_USER));
          }
          else {
            defer.reject(error);
          }
        });
        break;
      case ReportService.TYPE_ON_DEMAND_INSTRUCTION:
        AccountUserActivityService.getReportsOnDemand(filters).then(function(results){
          if (!results.meta) {
            results.meta = {
              previous: results.previous,
              next: results.next,
              count: results.count
            };
          }
          defer.resolve(results);
        }, function(error){
          if (filters['page']) {
            delete(filters['page']);
            FilterService.removeFilter('page');
            defer.resolve(service.filter(filters, ReportService.TYPE_ON_DEMAND_INSTRUCTION));
          }
          else {
            defer.reject(error);
          }
        });
        break;
      case ReportService.TYPE_EXISTING_DOCUMENTS:
        FolderFileService.getReports(filters).then(function(results){
          if (!results.meta) {
            results.meta = {
              previous: results.previous,
              next: results.next,
              count: results.count
            };
          }
          defer.resolve(results);
        }, function(error) {
          if (filters['page']){
            delete(filters['page']);
            FilterService.removeFilter('page');
            defer.resolve(service.filter(filters, ReportService.TYPE_EXISTING_DOCUMENTS));
          }
          else {
            defer.reject(error);
          }
        });
        break;
      case ReportService.TYPE_MISSING_DOCUMENTS:
        FolderFileService.getReportsMissing(filters).then(function(results){
          if (!results.meta) {
            results.meta = {
              previous: results.previous,
              next: results.next,
              count: results.count
            };
          }
          defer.resolve(results);
        }, function(error){
          if (filters['page']) {
            delete(filters['page']);
            FilterService.removeFilter('page');
            defer.resolve(service.filter(filters, ReportService.TYPE_MISSING_DOCUMENTS));
          }
          else {
            defer.reject(error);
          }
        });
        break;
      case ReportService.TYPE_WORK_ORDERS:
        filters['fetch_resident'] = true;
        WorkOrderService.getReports(filters).then(function(results){
          if (!results.meta) {
            results.meta = {
              previous: results.previous,
              next: results.next,
              count: results.count
            };
          }
          defer.resolve(results);
        }, function(error){
          if (filters['page']) {
            delete(filters['page']);
            FilterService.removeFilter('page');
            defer.resolve(service.filter(filters, ReportService.TYPE_WORK_ORDERS));
          }
          else {
            defer.reject(error);
          }
        });
        break;
      case ReportService.TYPE_WORK_ORDER_ACTIVITY:
        WorkOrderService.getActivityReports(filters).then(function(results){
          if (!results.meta) {
            results.meta = {
              previous: results.previous,
              next: results.next,
              count: results.count
            };
          }
          defer.resolve(results);
        }, function(error){
          if (filters['page']) {
            delete(filters['page']);
            FilterService.removeFilter('page');
            defer.resolve(service.filter(filters, ReportService.TYPE_WORK_ORDER_ACTIVITY));
          }
          else {
            defer.reject(error);
          }
        });
        break;
      case ReportService.TYPE_MIMO:
        DynamicFormDataRestService.getMimoReport(filters).then(function(results){
          if (!results.meta) {
            results.meta = {
              previous: results.previous,
              next: results.next,
              count: results.count
            };
          }
          defer.resolve(results);
        }, function(error){
          if (filters['page']) {
            delete(filters['page']);
            FilterService.removeFilter('page');
            defer.resolve(service.filter(filters, ReportService.TYPE_MIMO));
          }
          else {
            defer.reject(error);
          }
        });
        break;
      default:
        defer.reject();
        break;
    }
    return defer.promise;
  };


  service.showExportDialog = function(report) {
    ngDialog.open({
      template: 'views/templates/dialog/report/export.html',
      className: 'ngdialog-theme-default ngdialog-export',
      controller: 'ExportReportDialog',
      data: {
        mode: report.report_type,
        report_title: report.report_title,
        dynamic_form: report.dynamic_form,
        filters:report.filters,
        is_user_report: report.is_user_report
      }
    });
  };

  return service;
};

app.factory('ReportFilterService', ['FilterService', 'TaskService', 'AccountUserActivityService', 'WorkFlowInstanceService',
  'DynamicFormDataRestService', 'AccountService', 'ReportService', 'ngDialog', '$q', 'TemplateService', 'PropertyService',
  'AccountUserService', 'FolderFileService', 'WorkOrderService', 'PropertyAmenityService', 'ContactRestService', ReportFilterService]);
